import { Box, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import uniqid from 'uniqid';
import { MenuCategory } from '../../../apiTypes';
import EditModal from '../../../components/EditModal';
import FormSwitch from '../../../components/forms/FormSwitch';
import FormTextField from '../../../components/forms/FormTextField';
import FormUploadImg from '../../../components/FormUploadImg';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';
import { deleteDoc, setDoc, updateDoc } from '../../../utils/api';

type Props = {
  open: boolean;
  category?: DbDocument<MenuCategory> | null;
  onClose: () => void;
  sectionId: string;
  lastIndex: number;
};

const EditCategory = ({ category, open, sectionId, onClose, lastIndex }: Props) => {
  const { cafeSlug } = useAdmin();
  const { lang } = useLocale();
  const { categories } = useCafe();

  const form = useForm<MenuCategory>({
    mode: 'onChange',
    defaultValues: {
      name: category?.name || '',
      description: category?.description || '',
      imageUrl: category?.imageUrl || '',
      sectionId,
      show: category?.show !== false,
      order: category?.order || lastIndex + 1,
    },
  });

  const handleClose = () => {
    onClose();
    form.reset();
  };

  const saveChanges = (newCategory: MenuCategory) => {
    if (category?.id) {
      updateDoc<MenuCategory>(`cafes/${cafeSlug}/categories/${category.id}`, newCategory);
    } else {
      setDoc<MenuCategory>(`cafes/${cafeSlug}/categories/${uniqid()}`, newCategory);
    }

    handleClose();
  };

  const removeProduct = async () => {
    if (category?.id) {
      // stores.forEach((store) => {
      //   updateDoc(doc(db, "company", companySlug, "stores", store.id), {
      //     [`residues.${consumable.id}`]: deleteField(),
      //   });
      // });
      deleteDoc(`cafes/${cafeSlug}/categories/${category.id}`);
      handleClose();
    }
  };

  return (
    <EditModal<MenuCategory>
      title={t.category[lang]}
      open={open}
      onClose={handleClose}
      submitButton={category ? t.save_changes[lang] : t.add[lang]}
      onSubmit={saveChanges}
      secondaryButton={category ? t.remove[lang] : undefined}
      confirmText={t.remove_category_confirm[lang]}
      onSecondaryButtonClick={removeProduct}
      form={form}
      size="xs"
    >
      <Box sx={{ py: 2, mb: 1 }}>
        <Box sx={{ mb: 3 }}>
          <FormUploadImg name="imageUrl" folder="categories" />
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <FormTextField name="name" label={t.name[lang]} rules={{ required: true }} fullWidth />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormTextField name="description" multiline rows={4} label={t.category_description[lang]} fullWidth />
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormSwitch name="show" label={t.show_category_for_visitors[lang]} />
          </Grid>
        </Grid>
      </Box>
    </EditModal>
  );
};

export default EditCategory;
